import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignupForm from "../components/SignupFormCN";
import { BranchAPI } from "../../../../pages/Auth/api";
import { registerRequested, selectAuth } from "../../../../pages/Auth/slice";
import { useNavigate } from "react-router-dom";

export default function SignupContainerCN() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { signupStatus, signupError } = useSelector(selectAuth);

  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(true);
  const [branchError, setBranchError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const list = await BranchAPI.getList({ status: 1 });
        setBranches(list);
      } catch (e) {
        setBranchError(e?.message || "지점 리스트를 불러오지 못했습니다.");
      } finally {
        setLoadingBranches(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (signupStatus === "succeeded") {
      alert("注册成功。");
      nav("/cn/profiling");
    }
  }, [signupStatus, nav]);

  return (
    <div className="signupfield">
      {/* 지점 로드 실패/진행 중이어도 폼은 항상 노출 */}
      {branchError && <p className="error">지점 로드 실패: {branchError}</p>}
      {loadingBranches && <p>지점 정보를 불러오는 중…</p>}
      <SignupForm
        branches={branches}          // 실패 시 빈 배열 전달
        onSubmit={(payload) => dispatch(registerRequested(payload))}
        loading={signupStatus === "loading"}
        error={signupError}
      />
    </div>
  );
}
